import React from 'react';
import HeadingDescription from '../HeadingDescription';
import PointersWithHeading from '../PointersWithHeading';
import ProposalImage from '../ProposalImage';
import TechnicalDataTable from '../TechnicalDataTable';

export default function DustCollectorSection({ dustCollectorContent, dustCollectorImage, dustCollectorTables = [], isUploadedImage = false }) {
  const hasDustCollector = dustCollectorContent || dustCollectorTables.length > 0;
  if (!hasDustCollector) return null;

  return (
    <>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          <div className="quotation-section-block">
            <HeadingDescription heading="Dust Collector" description="" level={2} />
            <HeadingDescription
              heading={dustCollectorContent?.title || 'Dust Collector'}
              description={dustCollectorContent?.description || ''}
              level={3}
            />
            {dustCollectorContent?.items?.items && (
              <PointersWithHeading
                items={dustCollectorContent.items.items.map((it) => ({ title: it.title, description: it.description }))}
                numbered
              />
            )}
            {dustCollectorImage && (
              <ProposalImage
                src={dustCollectorImage}
                wrapperStyle={{ marginBottom: 12, marginTop: 12, width: '50%', maxWidth: '50%', marginLeft: 'auto', marginRight: 'auto' }}
                imgStyle={isUploadedImage ? { maxHeight: 500, width: 'auto', objectFit: 'contain' } : { width: '100%', maxWidth: '100%' }}
              />
            )}
          </div>
        </div>
      </div>
      {dustCollectorTables.length > 0 && (
        <div className="a4-paddings quotation-page quotation-page-compact">
          <div className="quotation-page-inner quotation-bg-light">
            {dustCollectorTables.map((table) => (
              <TechnicalDataTable
                key={table.id}
                data={table.data}
                headers={table.headers}
                title={table.label}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
